import { css } from '@emotion/css';

const popperStyles = css`
  width: 40rem !important;
`;

const tagAndUserpopperStyles = css`
  width: 36rem !important;
`;

export const autocompleteClasses = {
  popper: popperStyles,
};

export const tagsAndUserAutocompleteClasses = {
  ...autocompleteClasses,
  popper: tagAndUserpopperStyles,
};
